class LWMagazine extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host { 
                display: block; 
                width: 100%; 
                height: 100vh; 
                overflow: hidden; 
            }

            .magazine-container { 
                display: grid; 
                grid-template-columns: 1fr 1fr; 
                height: 100vh; 
                width: 100%;
            }

            .panel {
                height: 100vh;
                overflow-y: auto;
                position: relative;
                /* Zorg dat de slot de volledige ruimte vult */
                display: flex;
                flex-direction: column;
            }

            /* Belangrijk: dwing de geprojecteerde elementen naar 100% hoogte */
            slot {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 100%;
            }

            @media (max-width: 767px) {
                :host { height: auto; overflow: visible; }
                .magazine-container { 
                    height: auto; 
                    display: flex; 
                    flex-direction: column; 
                }
                .panel { height: 100vh; }
                .left-panel {
                    display: none; /* Jouw eis: links weg op mobiel */
                }
            }
        </style>
        <div class="magazine-container">
            <section class="panel left-panel">
                <slot name="left"></slot>
            </section>
            <section class="panel right-panel">
                <slot name="right"></slot>
            </section>
        </div>
        `;
    }
}
if (!customElements.get('lw-magazine')) {
    customElements.define('lw-magazine', LWMagazine);
}